import React from 'react';
import './styles.scss';

export default function InvalidQtyMessage() {
  return (
    <p className="invalid-qty-message">
      {Drupal.tt("Le quantità selezionate non corrispondono alle quantità minime/multiple ordinabili pertanto sarà necessario richiedere un preventivo dedicato per quantificare l'ammontare del totale.")}
    </p>
  );
}
